import { useEffect, useState } from "react";

/* Shared tokens + timing for the landing-page auth consoles. */

export const inputClass =
  "min-w-0 flex-1 bg-transparent text-[14px] text-(--lp-term-fg) outline-none placeholder:text-(--lp-term-dim)";

export const buttonClass =
  "flex flex-1 items-center justify-center gap-2.5 rounded-md bg-[linear-gradient(180deg,var(--color-primary),var(--color-primary-hover))] px-5 py-3.5 text-[14px] font-semibold text-(--color-text-on-primary) shadow-[0_0_18px_var(--color-shadow-primary)] transition-all duration-300 hover:shadow-[0_0_30px_var(--color-shadow-primary-hover)] disabled:opacity-50 disabled:shadow-none";

export const ghostButtonClass =
  "lp-term-rule rounded-md border px-6 py-3.5 text-[13.5px] text-(--lp-term-dim) transition-colors hover:border-(--color-primary) hover:text-(--color-primary)";

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* Half-step counter: line `i` shows at `step >= i * 2`, its `ok` at `> i * 2`. */
export function useSequence(count, interval, running = true) {
  const settled = prefersReducedMotion() ? count * 2 : 0;
  const [step, setStep] = useState(settled);

  // Rewind on stop so a retry replays from the top.
  useEffect(() => {
    if (!running) setStep(settled);
  }, [running, settled]);

  useEffect(() => {
    if (!running || step >= count * 2) return;
    const id = setTimeout(() => setStep((current) => current + 1), interval);
    return () => clearTimeout(id);
  }, [running, step, count, interval]);

  return step;
}
